import htmlParse from "html-react-parser";
import { useEffect, useState } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import RxPaper from "../../components/RxPaper";
import api from "../../config/AxiosConfig";
import { SuccessResponseDTO } from "../../constants/CommonObject";
import { isNullOrUndefined } from "../../utils/CommonFunctions";
import styles from "./InfoPage.module.css";

interface InfoContentObject {
	contentType: "component" | "html-text";
	content?: any;
}

interface InfoPageProps {
	infoContent?: InfoContentObject;
	infoUrl?: string;
}

const InfoPage = (props: InfoPageProps) => {
	const { infoDocVersion }: any = useParams();
	const [contentFromUrl, setContentFromUrl] = useState<string>("");

	const userLoggedIn: boolean = useSelector(
		(state: RootStateOrAny) => state.user.userLoggedIn
	);

	useEffect(() => {
		if (props.infoUrl) {
			const requestUrl = !isNullOrUndefined(infoDocVersion)
				? props.infoUrl + "?version=" + infoDocVersion
				: props.infoUrl;
			api.get(requestUrl)
				.then((responseData: SuccessResponseDTO) => {
					setContentFromUrl(responseData.responseValue);
				})
				.catch((ex) => {
					setContentFromUrl("");
					// Talep ile hatalar ele alınacak ve bilgilendirilecek
					console.log(ex);
				});
		}
	}, [infoDocVersion, props.infoUrl]);

	return (
		<RxPaper
			className={
				styles.maxWidth + " " + (!userLoggedIn ? styles.mainPaper : "")
			}
		>
			<>
				{props.infoUrl && htmlParse(contentFromUrl)}
				{props.infoContent?.contentType === "html-text"
					? htmlParse(props.infoContent?.content)
					: props.infoContent?.content}
			</>
		</RxPaper>
	);
};

export default InfoPage;
